import Button from 'components/shared/Button/Button';

const Footer = ({
  isFooter,
  footer,
  showKeepEditingButton,
  secondaryBtn,
  secondaryBtnTxt,
  handleClose,
  primaryBtn,
  primaryBtnTxt,
  variant,
  loading,
  disabled,
  handleContinue
}) => {
  if (!isFooter) return null;
  if (typeof footer === 'object') return footer;

  return (
    <div className="flex flex-wrap-reverse justify-end gap-3 px-4 py-3">
      {showKeepEditingButton && (
        <Button
          size="small"
          className="text-xs text-neutral-700"
          variant="link"
          color="neutral"
          icon="edit-2-mono"
          iconColor="neutral"
          text="Keep editing"
          onClick={handleClose}
        />
      )}
      {typeof secondaryBtn === 'object'
        ? secondaryBtn
        : !showKeepEditingButton &&
          !typeof secondaryBtn !== 'object' && (
            <Button
              data-qa="close-confirm-modal-btn"
              color="neutral"
              style="outlined"
              size="small"
              text={secondaryBtnTxt}
              onClick={handleClose}
            />
          )}
      {typeof primaryBtn === 'object' ? (
        primaryBtn
      ) : (
        <Button
          data-qa="proceed-confirm-modal-btn"
          size="small"
          color={variant}
          text={primaryBtnTxt}
          isLoading={loading}
          isDisabled={disabled}
          onClick={handleContinue}
        />
      )}
    </div>
  );
};

export default Footer;
